
import { Component, Vue, Watch } from "vue-property-decorator";
import RegistroPresolicitud from "../models/RegistroPresolicitud";
import Presolicitud from "../models/Presolicitud";
import AfiliadoService from "@/services/AfiliadoService";
import RegistroDocumentosPresolicitud from "../models/RegistroDocumentosPresolicitud";
import { AxiosResponse } from "axios";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import CatalogoResponse from "../models/CatalogoResponse";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import Swal from "sweetalert2";
import { Getter } from "vuex-class";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import { VueFilePondComponent } from "vue-filepond";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import FileConfig from "../FileConfig";
import { formatCedula } from "@/utils/HelperFunctions";

@Component({})
export default class RegistroFallecimiento extends Vue {
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public documentos: Array<File> = [];
  public registroPresolicitud: RegistroPresolicitud = new RegistroPresolicitud();
  public registroDocumentosPresolicitud: RegistroDocumentosPresolicitud = new RegistroDocumentosPresolicitud();
  public parentescos: Array<CatalogoResponse> = [];
  public parentescosLoading: boolean = false;
  public parentesco: CatalogoResponse = null;
  public numeroSolicitud: number = null;
  public archivosRemovidos: Array<DocumentoPresolicitud> = [];
  public archivos: Array<DocumentoPresolicitud> = [];
  @Getter("cedulaFallecido") cedulaFallecido: string;
  @Getter("requiereDocumento") requiereDocumento: boolean;
  public showFileRequiredError: boolean = false;
  public showInvalidFileTypeError: boolean = false;
  public showInvalidFileSizeError: boolean = false;
  public showServerError: boolean = false;
  public showServerValidationMessage: boolean = false;
  public serverValidationMessage = "";
  public isEditing = false;
  public loadingData = false;
  public currentPresolicitud: Presolicitud = new Presolicitud();
  public fileConfig: FileConfig = new FileConfig();

  get saveButtonText(): string {
    return this.isEditing ? "Guardar" : "Registrar";
  }

  get successOperationMessage(): string {
    return this.isEditing ? "Operación exitosa" : "Fallecimiento registrado";
  }

  get saveButtonIsDisable(): boolean {
    return this.isEditing && !this.currentPresolicitud.esModificable;
  }

  get nombreAfiliado() {
    return (
      this.currentPresolicitud.nombreAfiliado ||
      this.$store.getters.nombreAfiliadoFallecido
    );
  }

  get cedulaAfiliadoFallecido() {
    return (
      this.currentPresolicitud.cedulaAfiliado ||
      this.$store.getters.cedulaFallecido
    );
  }

  @Watch("showInvalidFileTypeError")
  public async onInvalidFileType(newValue, oldValue) {
    let invalidClass = "invalid-file";
    let element = (this.$refs.pond as VueFilePondComponent).$el as HTMLElement;
    if (newValue) {
      let classList = element.className.split(" ");
      if (classList.indexOf(invalidClass) == -1) {
        element.className += " " + invalidClass;
      }
    } else {
      let classList = element.className.split(" ");
      let classIndex = classList.indexOf(invalidClass);
      classList.splice(classIndex, 1);
      element.className = classList.join(" ");
    }
  }

  public async mounted() {
    let cedulaUsuario = this.$store.getters.user.cedula;
    // Validate if user can proceed
    if (this.cedulaAfiliadoFallecido == cedulaUsuario) {
      Swal.fire({
        text:
          "El usuario consultante no puede ser el mismo afiliado fallecido.",
        icon: "error",
        showConfirmButton: false,
        timer: 8000,
        onClose: () => {
          this.$router.push("/solicitudes-beneficiario");
        },
      });
    }
    this.scrollToTop();
    await this.getParentescos();

    if (this.$route.query.numeroSolicitud) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      if (this.numeroSolicitud) {
        this.isEditing = true;
        this.loadingData = true;
        await this.getPresolicitud();
        await this.getDocumentosPresolicitud();
      }
    }
  }

  public async getParentescos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.parentescosLoading = true;
    const response = await this.afiliadoService.parentescos(term);
    if (response.data.entity) {
      this.parentescos = response.data.entity;
    } else {
      this.parentescos = [];
    }
    this.parentescosLoading = false;
  }

  public async getPresolicitud() {
    this.afiliadoService
      .getPresolicitud(
        new ParametrosObtencionPresolicitud(
          this.numeroSolicitud,
          this.$store.getters.user.cedula,
          null,
          null
        )
      )
      .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
        if (response.data.solicitudes && response.data.solicitudes.length > 0) {
          this.currentPresolicitud = response.data.solicitudes.find(
            (x) => x.numeroSolicitud == this.numeroSolicitud
          );
          if (this.currentPresolicitud) {
            this.parentesco = this.parentescos.find(
              (x) => x.value === this.currentPresolicitud.parentesco
            );
            this.registroPresolicitud.presolicitud.observaciones = this.currentPresolicitud.observaciones;
            this.registroPresolicitud.presolicitud.cedulaAfiliado = this.currentPresolicitud.cedulaAfiliado;
            this.registroDocumentosPresolicitud.cedulaFallecido = this.currentPresolicitud.cedulaAfiliado;
          }
        } else {
          this.$router.push("/solicitudes-beneficiario");
        }
      });
  }

  public async getDocumentosPresolicitud() {
    this.afiliadoService
      .getDocumentosPresolicitud(this.numeroSolicitud)
      .then((response: AxiosResponse<ServiceResponseArchivos>) => {
        this.archivos = response.data.archivos;
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  public onAddOrRemoveFile(): void {
    let pond: any = this.$refs.pond;
    this.documentos = pond.getFiles().map((x) => x.file);
    this.showFileRequiredError = true;
    const anyFileTypeInvalid: boolean = this.documentos.some(
      (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
    ); 
     const anyFileExtensionInvalid: boolean = this.documentos.some(
      (x) =>   this.fileConfig.notAllowExtensions.some(substring=>x.name.includes(substring))
    );
      if(anyFileExtensionInvalid || anyFileTypeInvalid){
           this.showInvalidFileTypeError  = true;
      }else{
           this.showInvalidFileTypeError = false;
      }


    const anyFileSizeInvalid: boolean = this.documentos.some(
      (x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit
    );
    this.showInvalidFileSizeError = anyFileSizeInvalid;
    this.showServerValidationMessage = false;
  }

  public async register() {
    const anyFile: boolean = !(
      this.archivos.length === 0 && this.documentos.length === 0
    );
    if (!anyFile) {
      this.showFileRequiredError = true;
      this.scrollToActa();
      return;
    }
    const anyFileTypeInvalid: boolean = this.documentos.some(
      (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
    );
    if (anyFileTypeInvalid) {
      this.showInvalidFileTypeError = true;
      this.scrollToActa();
      return;
    }
    (this.$refs.fallecidosForm as VeeValidateForm)
      .validate()
      .then((isValid: boolean) => {
        const hasParentesco: boolean = !!this.parentesco;
        if (!this.saveButtonIsDisable) {
          if (isValid && hasParentesco) {
            Swal.fire({
              text: "¿Deseas continuar?",
              icon: "warning",
              showCancelButton: true,
              cancelButtonText: "Cancelar",
              confirmButtonColor: "#ED8B2F",
              cancelButtonColor: "#0F6CBC",
              confirmButtonText: "OK",
              reverseButtons: true,
            }).then(async (result) => {
              if (result.value) {
                Swal.fire({
                  text: "Se están registrando los datos",
                  icon: "info",
                  timerProgressBar: true,
                  onBeforeOpen: () => {
                    Swal.showLoading();
                  },
                  allowOutsideClick: false,
                });
                this.registroPresolicitud = this.setRegistroPresolicitud();
                this.registroPresolicitud.archivosEliminados = this.archivosRemovidos;
                this.afiliadoService
                  .registroPresolicitud(this.registroPresolicitud, {
                    actaDefuncion: this.documentos,
                  })
                  .then((response: AxiosResponse<ServiceResponse>) => {
                    if (response.data.respCode === 200) {
                      Swal.close();
                      this.onRegisterSuccessful();
                    } else if (response.data.respCode === 400) {
                      Swal.close();

                      this.serverValidationMessage = response.data.message;
                      this.showServerValidationMessage = true;
                      this.scrollToTop();
                    }
                  })
                  .catch(() => {
                    Swal.close();
                    this.showServerError = true;
                  });
              } else {
                this.scrollToTop();
              }
            });
          } else {
            this.scrollToTop();
          }
        }
      })
      .catch(() => {
        Swal.close();
        Swal.fire({
          text: "Ocurrió un error validando el formulario, inténtalo de nuevo",
          icon: "error",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

  public setRegistroPresolicitud(): RegistroPresolicitud {
    const registroPresolicitud: RegistroPresolicitud = new RegistroPresolicitud();
    registroPresolicitud.presolicitud.tipoBeneficio = TipoBeneficioEnum.Fallecimiento.toString();
    registroPresolicitud.presolicitud.numeroSolicitud = this.numeroSolicitud;
    registroPresolicitud.presolicitud.codCuenta = this.$store.state.user.codCuenta;
    registroPresolicitud.presolicitud.cedulaBeneficiario = this.$store.state.user.cedula /* '40213282383' */;
    registroPresolicitud.presolicitud.parentesco = this.parentesco.value;
    registroPresolicitud.presolicitud.observaciones = this.registroPresolicitud.presolicitud.observaciones;

    if (!this.isEditing) {
      registroPresolicitud.presolicitud.cedulaAfiliado = this.cedulaFallecido /* '00101612232' */;
      this.registroDocumentosPresolicitud.cedulaFallecido = this.cedulaFallecido /* '00101612232' */;
      console.log(this.cedulaFallecido + " CEDULA FALLECIDO");
    }

    this.registroDocumentosPresolicitud.tipoBeneficio =
      TipoBeneficioEnum.Fallecimiento;
    this.registroDocumentosPresolicitud.numeroSolicitud = this.numeroSolicitud;
    registroPresolicitud.registroDocumentosPresolicitud = this.registroDocumentosPresolicitud;
    return registroPresolicitud;
  }

  public scrollToTop(): void {
    const top = this.$refs.top as any;
    setTimeout(() => {
      top.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }

  public scrollToActa(): void {
    const cintilloActa = this.$refs.cintilloActa as any;
    cintilloActa.scrollIntoView({ behavior: "smooth" });
  }

  public onRegisterSuccessful(): void {
    Swal.fire({
      text: this.successOperationMessage,
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
      onClose: () => {
        this.$router.push("/solicitudes-beneficiario");
      },
    });
  }

  public onRemoveArchivo(archivoPresolicitud: DocumentoPresolicitud): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    Swal.fire({
      text: "¿Deseas eliminar el archivo " + fileName + " ?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "OK",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        const index: number = this.archivos.indexOf(archivoPresolicitud);
        this.archivos.splice(index, 1);
        this.archivosRemovidos.push(archivoPresolicitud);
      }
    });
  }

  public openRequisitosInNewTab() {
    window.open(
      "https://afpsiembra.com/media/Formulario_Beneficios_por_Sobrevivencia_(web).pdf",
      "_blank"
    );
  }

  public redirectToSolicitudesBeneficiario() {
    this.$router.push("/solicitudes-beneficiario");
  }

  public formatUserCedula(cedula: string): string {
    return formatCedula(cedula);
  }
}
